module.exports = __webpack_public_path__ + "img/10.71bdd6ed.png";